import { z } from 'zod'

export type KeysOfType<T, V> = {
  [K in keyof T]-?: T[K] extends V ? K : never
}[keyof T]

export const pointSchema = z.object({
  type: z.literal('Point'),
  coordinates: z.array(z.number()),
})
